import { useI18n } from '@/lib/i18n';
import { useCart } from '@/lib/cart';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Trash2, ShoppingBag, ArrowRight } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const Cart = () => {
  const { t, lang } = useI18n();
  const { items, removeItem, total } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen pt-20">
      <div className="container mx-auto px-4 py-12 max-w-2xl">
        <h1 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-8 flex items-center gap-3">
          <ShoppingBag className="h-6 w-6 text-primary" />
          {t('cart')}
        </h1>

        {items.length === 0 ? (
          <div className="text-center py-20">
            <ShoppingBag className="h-16 w-16 text-muted-foreground/30 mx-auto mb-4" />
            <p className="text-muted-foreground mb-6">{t('emptyCart')}</p>
            <Link to="/gallery">
              <Button className="gradient-accent text-primary-foreground">
                {t('explorePaintings')}
              </Button>
            </Link>
          </div>
        ) : (
          <>
            <div className="space-y-3">
              {items.map(item => (
                <div key={item.id} className="flex items-center gap-4 p-4 glass-panel border-0 rounded-xl">
                  {item.image_url && (
                    <img src={item.image_url} alt={item.title} className="w-20 h-20 object-cover rounded-lg" />
                  )}
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-foreground truncate">
                      {lang === 'ar' && item.title_ar ? item.title_ar : item.title}
                    </p>
                    <p className="text-sm font-semibold text-primary">{t('currency')}{item.price}</p>
                  </div>
                  <Button variant="ghost" size="icon" onClick={() => removeItem(item.id)} className="text-muted-foreground hover:text-destructive">
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              ))}
            </div>

            <div className="mt-8 p-6 glass-panel border-0 rounded-xl">
              <div className="flex items-center justify-between mb-4">
                <span className="text-muted-foreground">{t('totalPrice')}</span>
                <span className="text-2xl font-bold text-primary">{t('currency')}{total}</span>
              </div>
              <Button
                className="w-full gradient-accent text-primary-foreground shadow-glow"
                size="lg"
                onClick={() => {
                  if (!user) { navigate('/auth'); return; }
                  navigate('/checkout');
                }}
              >
                {t('checkout')}
                <ArrowRight className={`h-4 w-4 ${lang === 'ar' ? 'mr-2 rotate-180' : 'ml-2'}`} />
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
